var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-autocomplete',{attrs:{"clearable":"","items":_vm.sortedInvoices,"item-text":i =>
    `${_vm.formatDate(i.date)}: ${i.invoiceNumber} - ${i.reference}`,"item-value":"invoiceID","label":"Invoice Number"}})
}
var staticRenderFns = []

export { render, staticRenderFns }